// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___2DjBR","navSection":"styles-module__navSection___3kysS"};